import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import TrebuchetRegular from "./Trebuchet-Regular.woff2";

export const TrebuchetFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: TrebuchetRegular,
    descriptors: { unicodeRange: GOOGLE_FONTS_RANGES.LATIN },
  },
];
